import React from "react";
import "../../css/sharedStyles.css";
import "./MoreButton.css";


var MoreButton = class MoreButton extends React.Component{
  constructor(props) {
      super(props);

      this.functionToCall = this.props.functionToCall;
  }  



  render() {
      var inlineStyle = {
        margin:this.props.margin
      }

      

      return (
        <div className="moreButton" style = {inlineStyle} onClick = {this.functionToCall}>
            <p>More </p>
            <span className="chevron right"></span>
        </div>  
      );
    }
  }

export default MoreButton;


// WEBPACK FOOTER //
// ./src/components/moreButton/MoreButton.js